module.exports = __webpack_public_path__ + "img/app-url-code.6a7c9a5c.png";